import styled from 'styled-components';
import {
  ICON_CHECK_CIRCLE_LINE,
  ICON_CHECK_CIRCLE_LINE_BLUE,
} from '@repo/assets';

type Props = {
  isRead: boolean;
  onClick: () => void;
};

export const CashPickupGuideCheckbox = ({ isRead, onClick }: Props) => {
  return (
    <Wrapper type='button' onClick={onClick} isRead={isRead}>
      {isRead ? (
        <img src={ICON_CHECK_CIRCLE_LINE_BLUE} alt='' width={24} height={24} />
      ) : (
        <img src={ICON_CHECK_CIRCLE_LINE} alt='' width={24} height={24} />
      )}
      Check the ‘Guide for Cash Pick-up’
    </Wrapper>
  );
};

export default CashPickupGuideCheckbox;

type StyleProps = {
  isRead: boolean;
};

const Wrapper = styled.button<StyleProps>`
  display: flex;
  padding: 14px;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid ${({ isRead }) => (isRead ? '#246CF6' : '#cbccce')};
  width: 100%;
  color: ${({ isRead }) => (isRead ? '#246CF6' : '#cbccce')};
  font-size: 14px;
  line-height: 150%; /* 21px */
`;
